import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/calendarViewV2Store';
import CalendarViewV2Container from '../containers/CalendarViewV2Container';

// See documentation for https://github.com/reactjs/react-redux.
// This is how you get props from the Rails view into the redux store.
// This code here binds your smart component to the redux store.
const CalendarViewV2App = (props) => (
  <Provider store={configureStore(props)}>
    <CalendarViewV2Container />
  </Provider>
);

export default CalendarViewV2App;
